// extracted by mini-css-extract-plugin
export var errorIcon = "_iz-1";
export var nameLogo = "_iz-0";